/**
 * Navigate to the locale root (e.g. `/` for English, `/fi`, `/sv`).
 * Used for clearSearch on non-actionable pages that don't have SearchProvider.
 *
 * The landing pages use injectScriptsAt:null (no Vike client bundle). Using
 * Vike's navigate() for them calls a no-op onRenderClient and the DOM never
 * updates. Hard-navigate so the browser fetches fresh server-rendered HTML.
 */
export async function navigateToLocaleRoot(locale: string): Promise<void> {
  const path = locale && ['en', 'fi', 'sv'].includes(locale) ? (locale === 'en' ? '/' : `/${locale}`) : '/';
  window.location.assign(path);
}
